import { render } from "./ProjectImage.vue?vue&type=template&id=cb3d7ee6"
import script from "./ProjectImage.vue?vue&type=script&lang=js"
export * from "./ProjectImage.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/staging/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__